import React, { Component } from 'react';
import AccountsReceivableBody from './Body/AccountsReceivableBody';
// esto es un intento de factory


class FactoryBody extends Component {

    getBody = () => {
        const { props } = this.props
        const { view } = props
        let header = <></>
        switch (view) {
            case 'AccountsReceivable':
                header = <AccountsReceivableBody
                    {...this.props}
                />
                break;

            default:
                header = null
                break;
        }
        return header

    }
    render() {
        return (
            this.getBody()
        );
    }
}

export default FactoryBody;
